import EntryField from './entry_field';
import SpecialSelect from './special_select';

export default class MultiFields {
	constructor(element) {
		this.list = element.querySelector('.multi_fields__list');
		this.element = element.querySelector(
			'.multi_fields__list .multi_fields__list__element:first-child'
		);
		this.counter =
			new Counter(element.querySelector('.multi_fields__controls'), this);
	}
}

class Counter {
	constructor(controls, multiFields) {
		this.multiFields = multiFields;
		this.next = controls.querySelector('.multi_fields__controls__next');
		this.prev = controls.querySelector('.multi_fields__controls__prev');
		this.count = controls.querySelector('.multi_fields__controls__count');

		this.next.addEventListener('click', this.addElement());
		this.prev.addEventListener('click', this.removeElement());
	}

	addElement() {
		return event => {
			let node = this.multiFields.element.cloneNode(true);
			node
				.querySelectorAll(
					'input:not([type="hidden"]):not([type="radio"]), textarea')
				.forEach(item => item.value = '');
			node.querySelectorAll('input, textarea').forEach(item => {
				item.name = item.name.replace(/\[\d\]/, `[${this.count.innerText}]`);
			});
			node.querySelectorAll('.entry_field').forEach(item => {
				new EntryField(item);
			});
			node.querySelectorAll('.special_select').forEach(item => {
				item.querySelector('.special_select__value').textContent = '';
				item.querySelectorAll('.entry_field__radio').forEach(item => {
					item.checked = false;
				});
				new SpecialSelect(item);
			});
			this.multiFields.list.appendChild(node);
			this.count.innerText = parseInt(this.count.innerText) + 1;
			this.prev.removeAttribute('disabled');
		};
	}

	removeElement() {
		return event => {
			if (parseInt(this.count.innerText) == 1) return;
			this.multiFields.list.lastElementChild.remove();
			this.count.innerText = parseInt(this.count.innerText) - 1;

			if (parseInt(this.count.innerText) == 1) {
				this.prev.setAttribute('disabled', 'disabled');
			}
		};
	}
}